export default __webpack_public_path__ + "static/media/logo.0c44900a.svg";